import { useState } from 'react';
import { Switch } from '@mui/material';
import toast from 'react-hot-toast';
import { useSetDirectMessagingMutation } from '../../../../generated/graphql';
import { useInfluencer } from '@client/new/hooks/use-influencer';
import { DirectMessagesModal } from './DirectMessagesModal';

export const DirectMessagesToggle = ({
  influencerId,
  isEnabledMessaging,
}: {
  influencerId: number;
  isEnabledMessaging: boolean;
}) => {
  const [isEnabled, setEnabled] = useState(isEnabledMessaging);
  const [openModal, setOpenModal] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const { refetchInfluencer } = useInfluencer({
    creatorId: influencerId,
  });

  const [setDirectMessagingMutation] = useSetDirectMessagingMutation();
  const onSubmit = async () => {
    setSubmitting(true);
    return await setDirectMessagingMutation({
      variables: {
        data: {
          influencerId,
          isEnabled: !isEnabled,
        },
      },
    })
      .then(() => {
        refetchInfluencer();
        toast.success(
          isEnabled
            ? 'Direct Messages have been successfully disabled.'
            : 'Direct Messages are now available!',
        );
        setEnabled((prev) => !prev);
      })
      .catch(() => {
        toast.error('Something went wrong!');
      })
      .finally(() => {
        setOpenModal(false);
        setSubmitting(false);
      });
  };

  return (
    <>
      <Switch checked={isEnabled} onChange={() => setOpenModal(true)} />
      <DirectMessagesModal
        open={openModal}
        toggle={() => setOpenModal((prev) => !prev)}
        onSubmit={onSubmit}
        isEnabled={isEnabled}
        isSubmitting={isSubmitting}
      />
    </>
  );
};
